import AuthMobileContainer from './AuthMobileContainer';
export default AuthMobileContainer;
